import { Injectable, inject } from '@angular/core';
import { BoelsState } from '../../reducers.index';
import { Store, select, Action } from '@ngrx/store';
import { getUserData, isLoading } from '../selectors/user-data.selectors';
import { Observable, filter } from 'rxjs';
import {
  clearUserData,
  requestLogin,
  requestLogout,
  setUserData,
} from '../actions/user-data.actions';
import { BoelsUser } from '@boels/models';
import { Actions, ofType } from '@ngrx/effects';

@Injectable({
  providedIn: 'root',
})
export class UserDataFacade {
  #store: Store<BoelsState> = inject(Store);
  #actions$: Actions = inject(Actions);

  requestLogin(redirectUrl?: string): void {
    this.#store.dispatch(requestLogin({ redirectUrl: redirectUrl }));
  }

  requestLoginDispatched$(): Observable<
    {
      redirectUrl?: string | undefined;
    } & Action<'[UserData] Request Login'>
  > {
    return this.#actions$.pipe(ofType(requestLogin));
  }

  requestLogout(redirectUrl?: string): void {
    this.#store.dispatch(requestLogout({ redirectUrl: redirectUrl }));
  }

  requestLogoutDispatched$(): Observable<
    {
      redirectUrl?: string | undefined;
    } & Action<'[UserData] Request Logout'>
  > {
    return this.#actions$.pipe(ofType(requestLogout));
  }

  userData(): Observable<BoelsUser> {
    return this.#store.select(getUserData).pipe(filter(Boolean));
  }

  isLoading(): Observable<boolean> {
    return this.#store.pipe(select(isLoading));
  }

  setUserData(user: BoelsUser): void {
    this.#store.dispatch(setUserData({ user: user }));
  }
  clearUser(): void {
    this.#store.dispatch(clearUserData());
  }
}
